import styled from "styled-components";

const CopyrightWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.8em;
    color: ${(props) => props.theme.MENU.SUBTITLE_COLOR};
    margin-top: 20px;
    margin-bottom: 20px;
`;

function Copyright() {
    return (
        <CopyrightWrapper>
            &copy; 2026 고태현 All rights reserved.
        </CopyrightWrapper>
    );
}

export default Copyright;